export { storeCodeEmitter, StoreCodeEmitter, DEFAULT_STORE_CODE } from './store-code-emitter';
export type { CookieAdapter } from './store-code-emitter';
export type {
    StoreCodeChangePayload,
    BeforeStoreCodeChangePayload,
    StoreCodeEventMap,
    StoreCodeChangeHandler,
    BeforeStoreCodeChangeHandler,
    StoreCodeChangeResult,
} from './store-code-emitter.types';
export { default as EventEmitter } from './event-emitter';
